module.exports = __webpack_public_path__ + "blue.ab26579a.png";